import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub,faLinkedin,faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import "./Home.css"
import { Link } from 'react-router-dom';
import axiosInstance from '../../axiosInstance';


const Home = () => {
  const [homeData, setHomeData] = useState({
    _id: '',
    description: '',
    links: []
  });

  useEffect(() => {
    fetchHomeData();
  }, []);

  const fetchHomeData = async () => {
    try {
      const response = await axiosInstance.get('/home');
      console.log(response.data);
      setHomeData(response.data);
    } catch (error) {
      console.error('Error fetching home data:', error);
    }
  };

  return (
    <div className='pt-[12rem] max-sm:px-8 px-4 max-w-7xl mx-auto py-6'>
      <div>
        <span className='text-xl text-blue-400 dark:text-yellow-400 pb-1 font-semibold '>Hi, I'm</span><br />
        <h1 className={`text-5xl text-gray-900 dark:text-[rgb(211,219,236)] font-semibold `}>Sellam Ezzahraoui</h1>
      </div>
      <div>
        <p className='text-lg text-gray-900 dark:text-[rgb(211,219,236)] pt-8 font-light w-2/3 max-sm:w-full'>
          {homeData?.description??"d"}
        </p>
      </div>
      <div>
        <h1 className='text-lg text-gray-900 dark:text-[rgb(211,219,236)] pt-4 font-light'>Follow me:
            <a href={homeData?.links[0]} className='ml-2'>
              <FontAwesomeIcon icon={faGithub} className='text-gray-900 dark:text-[rgb(211,219,236)] px-1 hover:scale-125 transition-transform duration-200' />
            </a>
            <a href={homeData?.links[1]} className='ml-2'>
              <FontAwesomeIcon icon={faLinkedin} className='text-gray-900 dark:text-[rgb(211,219,236)] px-1 hover:scale-125 transition-transform duration-200' />
            </a>
            <a href={homeData?.links[2]} className='ml-2'>
              <FontAwesomeIcon icon={faXTwitter} className='text-gray-900 dark:text-[rgb(211,219,236)] px-1 hover:scale-125  transition-transform duration-200'/>
            </a>
        </h1>
      </div>
      <div className='pt-8'>
        <Link to="/about" className='text-xl text-gray-900 dark:text-[rgb(211,219,236)] font-semibold nav-link'>Know more about me  <FontAwesomeIcon icon={faArrowRight} className='animate-pulse' /></Link>
      </div>
    </div>
  );
};


export default Home;




